import styled from "styled-components";
import { SecondaryButtonAtom } from "./Generic/SecondaryButton";
import { useSettingsStorageContext } from "../ContextLayer/SettingsStorageProvider";

const LightSwitchButtonAtom = styled(SecondaryButtonAtom)<{$darkMode: boolean}>`
    width: 30px;
    height: 30px;
    background: rgba(255, 255, 255, 0.2);

    & svg path {
        fill: ${props => props.$darkMode ? '#FEF7E2' : '#555351'};
        transition: fill var(--transition-duration-slow)
    }
`

export interface LightSwitchButtonProps {

}

export default function LightSwitchButton(props: LightSwitchButtonProps) {
    const { settings, setSettings } = useSettingsStorageContext();

    const toggleDarkMode = () => {
        localStorage.setItem("darkMode", (!settings.darkMode) + "");
        setSettings({
            ...settings,
            darkMode: !settings.darkMode
        });
    }

    return (
        <LightSwitchButtonAtom onClick={toggleDarkMode} $darkMode={settings.darkMode}>
            <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.5 9C14.15 9 15.5 10.35 15.5 12C15.5 13.65 14.15 15 12.5 15C10.85 15 9.5 13.65 9.5 12C9.5 10.35 10.85 9 12.5 9ZM12.5 7C9.74 7 7.5 9.24 7.5 12C7.5 14.76 9.74 17 12.5 17C15.26 17 17.5 14.76 17.5 12C17.5 9.24 15.26 7 12.5 7ZM2.5 13H4.5C5.05 13 5.5 12.55 5.5 12C5.5 11.45 5.05 11 4.5 11H2.5C1.95 11 1.5 11.45 1.5 12C1.5 12.55 1.95 13 2.5 13ZM20.5 13H22.5C23.05 13 23.5 12.55 23.5 12C23.5 11.45 23.05 11 22.5 11H20.5C19.95 11 19.5 11.45 19.5 12C19.5 12.55 19.95 13 20.5 13ZM11.5 2V4C11.5 4.55 11.95 5 12.5 5C13.05 5 13.5 4.55 13.5 4V2C13.5 1.45 13.05 1 12.5 1C11.95 1 11.5 1.45 11.5 2ZM11.5 20V22C11.5 22.55 11.95 23 12.5 23C13.05 23 13.5 22.55 13.5 22V20C13.5 19.45 13.05 19 12.5 19C11.95 19 11.5 19.45 11.5 20ZM6.49 4.58C6.1 4.19 5.46 4.19 5.08 4.58C4.69 4.97 4.69 5.61 5.08 5.99L6.14 7.05C6.53 7.44 7.17 7.44 7.55 7.05C7.93 6.66 7.94 6.02 7.55 5.64L6.49 4.58ZM18.86 16.95C18.47 16.56 17.83 16.56 17.45 16.95C17.06 17.34 17.06 17.98 17.45 18.36L18.51 19.42C18.9 19.81 19.54 19.81 19.92 19.42C20.31 19.03 20.31 18.39 19.92 18.01L18.86 16.95ZM19.92 5.99C20.31 5.6 20.31 4.96 19.92 4.58C19.53 4.19 18.89 4.19 18.51 4.58L17.45 5.64C17.06 6.03 17.06 6.67 17.45 7.05C17.84 7.43 18.48 7.44 18.86 7.05L19.92 5.99ZM7.55 18.36C7.94 17.97 7.94 17.33 7.55 16.95C7.16 16.56 6.52 16.56 6.14 16.95L5.08 18.01C4.69 18.4 4.69 19.04 5.08 19.42C5.47 19.8 6.11 19.81 6.49 19.42L7.55 18.36Z" fill="black"/>
            </svg>
        </LightSwitchButtonAtom>
    )
}